import AllRoutes from './all.routes'
import store from '../store/index.js'

import About from "@/views/client/about/ClientAbout.vue"

import AuditAdd from "@/views/client/audit/ClientAuditAdd.vue"
import AuditFeed from "@/views/client/audit/ClientAuditFeed.vue"
import Audit from "@/views/client/audit/ClientAudit.vue"

import Form from "@/views/client/form/ClientForm.vue"
import FormAnswer from "@/views/client/form/ClientFormAnswer.vue"
import FormCreateTask from "@/views/client/form/ClientFormCreateTask.vue"

import Help from "@/views/client/help/ClientHelp.vue"

import Gallery from "@/views/client/gallery/ClientGallery.vue"
import GalleryEdit from "@/views/client/gallery/ClientGalleryEdit.vue"

import TradePoints from "@/views/client/tradePoints/ClientTradePoints.vue"
import TradePointsEdit from "@/views/client/tradePoints/ClientTradePointEdit.vue"
import TradePointsView from "@/views/client/tradePoints/ClientTradePointView.vue"

import Settings from "@/views/client/settings/ClientSettings.vue"

const ifAuthenticated = (to, from, next) => {

    if (store.getters.isAuthenticated) {
        next()
        return
    }

    next('/Account/Login')
}

export default [

    {
        path: AllRoutes.Client.About.Index,
        component: About,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "О приложении"
        },

    },

    {
        path: AllRoutes.Client.Feed,
        component: AuditFeed,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Лента"
        },

    },

    {
        path: AllRoutes.Client.Audit.Add,
        component: AuditAdd,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Создание аудита"
        }
    },

    {   
        name: AllRoutes.Client.Audit.Index,
        path: AllRoutes.Client.Audit.Index,
        component: Audit,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "",
            backLink: AllRoutes.Client.Feed
        }
    },

    {
        path: AllRoutes.Client.Help.Index,
        component: Help,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Книга стандартов"
        }
    },

    {
        path: AllRoutes.Client.Gallery.Index,
        component: Gallery,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Фотографии",
            backLink: ""
        }
    },

    {
        name: AllRoutes.Client.Gallery.Edit,
        path: AllRoutes.Client.Gallery.Edit,
        component: GalleryEdit,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Фотографии"
        }
    },

    {
        path: AllRoutes.Client.Form.Index,
        component: Form,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Анкета",
            backLink: ""
        }
    },

    {
        path: AllRoutes.Client.Form.Answer,
        component: FormAnswer,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Ответ на вопрос",
            backLink: ""
        }
    },

    {
        path: AllRoutes.Client.Form.CreateTask,
        component: FormCreateTask,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Создание задачи"
        }
    },

    {
        path: AllRoutes.Client.TradePoints.Index,
        component: TradePoints,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "emptyLayout",
            title: "Выбор торговой точки"
        }
    },

    {   name: AllRoutes.Client.TradePoints.Edit,
        path: AllRoutes.Client.TradePoints.Edit,
        component: TradePointsEdit,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Торговая точка"
        }
    },

    {
        name: AllRoutes.Client.TradePoints.View,
        path: AllRoutes.Client.TradePoints.View,
        component: TradePointsView,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Информация о торговой точке"
        }
    },

    {
        path: AllRoutes.Client.Settings.Index,
        component: Settings,
        beforeEnter: ifAuthenticated,
        meta: {
            layout: "clientLayout",
            title: "Настройки"
        },

    }

]